import "./Button.css";
export default function Button(props) {
  return <button className={props.btnStyle}>{props.btnText}</button>;
}
